import React from "react";
import EntriesSelector from "./EntriesSelector";
import SearchInput from "./SearchInput";
import { FileExportBtn } from "./FileExportBtn";
import FormDatePicker from "Common/Custom/ReactFlatpickr";


const TableHeader = ({ tabledata, date }) => {
  const {
    Entries,
    limit,
    onLimitChange,
    options,
    search = false,
    SearchInputValue,
    handleSearch,
    copy,
    csv,
    pdf,
    print,
    modifiedColumns,
    rows,
    prepareRow,
    BtnPosition,
    fileName,
    user,
    isDate,
    footerRow,
  } = tabledata;
  const {
    key,
    field,
    value,
    handleChange = () => { },
    error,
    selectMode,
    mode
  } = date;

  return (
    <>

      <div className="row g-3 align-items-center justify-content-between table-header mb-3">

        {/* Export Buttons */}
        {(copy || csv || pdf || print) && (
          <div className="col-12 text-lg-end ms-auto">
            <FileExportBtn
              copy={copy}
              csv={csv}
              pdf={pdf}
              print={print}
              modifiedColumns={modifiedColumns}
              rows={rows}
              prepareRow={prepareRow}
              BtnPosition={BtnPosition}
              fileName={fileName}
              user={user}
              footerRow={footerRow}
            />
          </div>
        )}


        {/* Entries Selector */}
        {Entries && (
          <div className="col-md-6 user-select-none col-12">
            <EntriesSelector
              limit={limit}
              onLimitChange={onLimitChange}
              options={options}
            />
          </div>
        )}



        {
          isDate && (
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 ms-auto">
              <FormDatePicker
                key={key}
                field={field}
                value={value}
                handleChange={handleChange}
                error={error}
                selectMode={selectMode}
                mode={mode}
                dateFormat="d-m-Y"
              />
            </div>)

        }

        {search && (
          <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <SearchInput value={SearchInputValue} onChange={handleSearch} />
          </div>
        )}







      </div>


    </>
  );
};

export default TableHeader;
